import { PHYSICS_PRESET_IDS, PHYSICS_PRESETS } from '../core/config';
import type { SessionConfig } from '../configuration/session-config';
import { VISUAL_PRESET_IDS, VISUAL_PRESETS } from '../rendering/visual-presets';

function requiredElement(root: ParentNode, selector: string): Element {
  const element = root.querySelector(selector);
  if (element === null) throw new Error(`Missing preset lab element: ${selector}`);
  return element;
}

function options(
  ids: readonly string[],
  presets: Readonly<Record<string, Readonly<{ label: string; description: string }>>>,
): string {
  return ids
    .map(
      (id) =>
        `<option value="${id}" title="${presets[id]?.description ?? ''}">${presets[id]?.label ?? id}</option>`,
    )
    .join('');
}

export class PresetLab {
  public constructor(root: HTMLElement, selection: SessionConfig) {
    if (!selection.labEnabled) return;
    const shell = requiredElement(root, '.game-shell') as HTMLElement;
    const element = document.createElement('aside');
    element.className = 'preset-lab';
    element.dataset.testid = 'preset-lab';
    element.innerHTML = `
      <strong>Preset lab</strong>
      <label>Physics<select data-preset="physics">${options(PHYSICS_PRESET_IDS, PHYSICS_PRESETS)}</select></label>
      <label>Visual<select data-preset="visual">${options(VISUAL_PRESET_IDS, VISUAL_PRESETS)}</select></label>
      <small>Changing a preset restarts; add a seed to compare identical runs.</small>
    `;
    shell.append(element);

    const physics = requiredElement(element, '[data-preset="physics"]') as HTMLSelectElement;
    const visual = requiredElement(element, '[data-preset="visual"]') as HTMLSelectElement;
    physics.value = selection.physicsId;
    visual.value = selection.visualId;
    physics.addEventListener('change', () => {
      this.selectPreset('physics', physics.value);
    });
    visual.addEventListener('change', () => {
      this.selectPreset('visual', visual.value);
    });
  }

  private selectPreset(parameter: 'physics' | 'visual', value: string): void {
    const url = new URL(window.location.href);
    url.searchParams.set(parameter, value);
    window.location.assign(url);
  }
}
